import React, { useState } from 'react';
import ProductCard from './ProductCard';

const imgUrl = (id) => `${process.env.REACT_APP_BACKEND_URL}/api/public/files/${id}`;

export const Banners = ({ banners }) => {
  if (!banners.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 pt-10" data-testid="mall-banners">
      <div className="flex md:grid md:grid-cols-3 gap-4 overflow-x-auto snap-x snap-mandatory pb-2">
        {banners.slice(0, 3).map((b, i) => (
          <div key={i} className="snap-start shrink-0 w-[80%] md:w-auto rounded-3xl overflow-hidden border border-white/10 bg-[#1C2541] cb-card-hover relative" data-testid={`mall-banner-${i}`}>
            <img src={imgUrl(b.file_id)} alt={b.title || 'Promoción'} loading="lazy" className="w-full aspect-[4/5] object-cover" />
            {(b.title || b.valid_until || b.branch) && <div className="absolute inset-x-0 bottom-0 p-3 bg-gradient-to-t from-black/80 to-transparent text-white">
              {b.title && <p className="cb-display text-2xl">{b.title}</p>}
              <p className="text-xs text-white/70">{b.branch}{b.valid_until ? ` · Válido hasta ${b.valid_until}` : ''}</p>
            </div>}
          </div>))}
      </div>
    </section>
  );
};

// Fila de 4 artículos por departamento con botón para desplegar todos (filas de 2 en móvil / 4 en escritorio)
export const DeptRow = ({ name, items, cardProps }) => {
  const [all, setAll] = useState(false);
  const shown = all ? items : items.slice(0, 4);
  return (
    <section className="max-w-7xl mx-auto px-4 pt-12" data-testid={`dept-${name}`}>
      <div className="flex items-end justify-between mb-4">
        <h2 className="cb-display text-3xl sm:text-4xl text-white">{name}</h2>
        {items.length > 4 && <button onClick={() => setAll(!all)} className="text-sm font-bold text-[#FFC857]" data-testid={`dept-toggle-${name}`}>{all ? 'Ver menos' : `Ver todos (${items.length})`}</button>}
      </div>
      <div className={`grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 ${all ? 'max-h-[80vh] overflow-y-auto pr-1' : ''}`}>
        {shown.map((p) => <ProductCard key={p.id} p={p} {...cardProps} />)}
      </div>
    </section>
  );
};

export default DeptRow;
